"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.experiments = undefined;

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _actions = require("../actions/actions");

var _get_parameter_by_name = require("../legacy/helpers/get_parameter_by_name");

var _get_parameter_by_name2 = _interopRequireDefault(_get_parameter_by_name);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Shows up when NODE_ENV != 'production', lets you switch between experiments
// experimentDebugger.enable();

var experiments = exports.experiments = {};
// import { emitter, Experiment } from "react-ab-test";
// import experimentDebugger from "react-ab-test/lib/debugger";


var globalEnvironment = global._nounConfig && global._nounConfig.environment;
var isProduction = !globalEnvironment || globalEnvironment == "production" || globalEnvironment == "staging";

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    // switch (action.type) {
    //     case actionTypes.GET_CURRENT_USER_SUCCESS:
    //         emitter.defineVariants(
    //             experiments.editor.name,
    //             experiments.editor.variants,
    //             experiments.editor.weights
    //         );

    //         let { response: user } = action;

    //         // let editor = "old";

    //         // if (user.is_beta || user.is_superuser) {
    //         if (user.is_beta || user.is_superuser || !isProduction) {
    //             // editor = "new";
    //             emitter.setActiveVariant(experiments.editor.name, "new");
    //         }

    //         if (user.is_superuser || !isProduction) {
    //             let wantsOld = getParameterByName("old");
    //             if (wantsOld) {
    //                 // editor = "old";
    //                 emitter.setActiveVariant(experiments.editor.name, "old");
    //             }
    //         }

    //         let userIdentifier = user.id;

    //         let checkExperiment = new Experiment({
    //             name: experiments.editor.name,
    //             userIdentifier: userIdentifier && userIdentifier.toString()
    //         });

    //         let editor = checkExperiment.getLocalStorageValue();

    //         let newState = {
    //             editor,
    //             userIdentifier
    //         };

    //         action.asyncDispatch(experimentsSet(newState));

    //         return newState;
    // }

    return state;
};